export function trackChunkTypeFrequency(eventType, counters) {
  if (!eventType || typeof counters !== 'object') return;
  counters[eventType] = (counters[eventType] || 0) + 1;
}

export function getSseEventType(eventName, data) {
  return eventName || data?.type || null;
}

export function getSseEventPayload(data) {
  return data?.payload ?? data;
}

export function normalizeChatMessage(rawMessage) {
  if (!rawMessage || typeof rawMessage !== 'object') {
    return null;
  }

  const role =
    rawMessage.role ||
    (rawMessage.agentId || rawMessage.agentName ? 'assistant' : null);
  if (!role) {
    return null;
  }

  const normalized = {
    ...rawMessage,
    role,
  };

  if (!normalized.sourceAgentId && rawMessage.agentId) {
    normalized.sourceAgentId = rawMessage.agentId;
  }
  if (!normalized.sourceAgentName && rawMessage.agentName) {
    normalized.sourceAgentName = rawMessage.agentName;
  }
  if (!normalized.senderDisplayName && rawMessage.senderName) {
    normalized.senderDisplayName = rawMessage.senderName;
  }
  if (!normalized.senderName && rawMessage.senderDisplayName) {
    normalized.senderName = rawMessage.senderDisplayName;
  }

  return normalized;
}

export function extractMessageAddedChatMessage(eventName, data) {
  const type = getSseEventType(eventName, data);
  if (type !== 'message_added') {
    return null;
  }

  const payload = getSseEventPayload(data);
  if (!payload || typeof payload !== "object" || !payload.message) {
    return null;
  }
  return normalizeChatMessage(payload.message);
}

export function extractUiChunkEnvelope(eventName, data) {
  const type = getSseEventType(eventName, data);
  if (type !== "ui_chunk") {
    return null;
  }
  const payload = getSseEventPayload(data);
  return payload && typeof payload === "object" ? payload : null;
}

export const TASK_QUEUE_SSE_EVENT_TYPES = new Set([
  'task_queue_created',
  'task_queue_updated',
  'task_started',
  'task_completed',
  'task_blocked',
  'task_failed',
  'task_skipped',
  'task_queue_completed',
  'task_queue_cancelled',
  'task_queue_recovered',
  'task_queue_paused_for_error',
]);

function normalizeQueueRevision(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function isTaskQueueSseEvent(eventType) {
  return TASK_QUEUE_SSE_EVENT_TYPES.has(String(eventType || '').trim());
}

export function extractTaskQueueEvent(eventName, data) {
  const type = getSseEventType(eventName, data);
  if (!isTaskQueueSseEvent(type)) {
    return null;
  }
  const payload = getSseEventPayload(data);
  if (!payload || typeof payload !== 'object') {
    return {
      type,
      queueId: '',
      revision: null,
      status: '',
      currentTaskId: '',
      changedTaskIds: [],
      action: '',
      timestamp: '',
      eventKey: `${type}:empty`,
    };
  }

  const queueId = String(payload.queueId || '').trim();
  const revision = normalizeQueueRevision(payload.revision);
  const status = String(payload.status || '').trim();
  const currentTaskId = String(payload.currentTaskId || '').trim();
  const changedTaskIds = Array.isArray(payload.changedTaskIds)
    ? payload.changedTaskIds
        .map((item) => String(item || '').trim())
        .filter((item) => Boolean(item))
    : [];
  const action = String(payload.action || '').trim();
  const timestamp = String(payload.timestamp || '').trim();
  const eventKey = `${type}:${queueId || '-'}:${revision ?? '-'}:${timestamp || '-'}`;

  return {
    type,
    queueId,
    revision,
    status,
    currentTaskId,
    changedTaskIds,
    action,
    timestamp,
    eventKey,
  };
}
